@if (response(); as response) {
  <div class="chart-result">
    @if (!response.success || response.error) {
      <div class="chart-result__error">
        {{ response.error || ('CHART_RESULT.FAILED' | translate) }}
      </div>
    } @else {
      @if (chartData(); as data) {
        <div class="chart-result__header">
          <div class="chart-result__titles">
            <span class="chart-result__title">{{ title() }}</span>
            @if (timeframeLabel()) {
              <span class="chart-result__timeframe">{{ timeframeLabel() }}</span>
            }
            @if (timeRangeLabel()) {
              <span class="chart-result__range">{{ timeRangeLabel() }}</span>
            }
          </div>

          <ui-button
            type="noBorderDefault"
            size="s"
            iconClass="ui-icon-fullscreen"
            [matTooltip]="'CHART_RESULT.EXPAND' | translate"
            (clickAction)="openExpanded()"
          ></ui-button>
        </div>

        <div class="chart-result__canvas">
          <app-chart-result-canvas
            [data]="data"
            [xAxisType]="response.xAxisType"
            [timeframe]="response.timeframe"
            [timezone]="response.timeRange?.timezone"
            [interactionHint]="'CHART_RESULT.CLICK_DETAILS' | translate"
            [isSelectionActionable]="isBarActionable"
            (barSelected)="onBarSelected($event)"
          ></app-chart-result-canvas>
        </div>

        <div class="chart-result__table" [style.height.px]="tableHeight()">
          <ui-dataset-table
            [data]="tableRows()"
            [config]="tableConfig()"
          ></ui-dataset-table>
        </div>
      } @else {
        <div class="chart-result__empty">{{ 'CHART_RESULT.EMPTY' | translate }}</div>
      }
    }
  </div>
}
